// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { DefaultPage } from '.';

export default {
  path: '',
  name: 'Pb payment details',
  childRoutes: [
    { path: 'booking', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'booking/:status', name: 'Default page', component: DefaultPage, isIndex: true },
    {
      path: 'booking/:status/:pnrNumber',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
    },

    { path: 'es/booking', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'es/booking/:status', name: 'Default page', component: DefaultPage, isIndex: true },
    {
      path: 'es/booking/:status/:pnrNumber',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
    },

    { path: 'en/booking', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'en/booking/:status', name: 'Default page', component: DefaultPage, isIndex: true },
    {
      path: 'en/booking/:status/:pnrNumber',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/route.js